(() => {
  'use strict';
  const script = document.getElementById('latrand-zipchat-layering-script');
  if (!script || script.dataset.initialised === 'true') return;
  script.dataset.initialised = 'true';

  const nativeRoots = '#CartDrawer, #x-header-mobile, latrand-navigation, .section-header, .drawer__wrapper, .sticky-add-to-cart__wrapper, .scroll-to-top__button';
  const nativeOpen = '#CartDrawer[open], #x-header-mobile.active, latrand-navigation.is-open, .section-header .toggle-menu.is-open:not([inert]), .drawer__wrapper.is-visible';
  const discovered = `${nativeRoots}, #zipchat-shadow-host, #zipchat-iframe`;
  const mobile = window.matchMedia('(max-width: 767px)');
  const styles = `
    #widget-chat-container[data-latrand-native-overlay],
    #widget-chat-container[data-latrand-native-overlay] #chat-preview-message {
      visibility: hidden !important;
      pointer-events: none !important;
    }
    #widget-chat-container[data-latrand-lifted] {
      margin-bottom: var(--latrand-zipchat-lift) !important;
    }
    #chat-preview-message[data-latrand-lifted] {
      bottom: var(--latrand-zipchat-preview-bottom) !important;
    }
  `;
  let host = null;
  let root = null;
  let bubble = null;
  let preview = null;
  let frame = 0;
  let style = null;
  let suppressed = false;
  let originallyInert = false;
  let watched = [];
  const scrollOffsets = new Map();
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const nativeObserver = new MutationObserver(schedule);
  const widgetObserver = new MutationObserver((records) => {
    if (records.some((record) => record.type === 'attributes' || Array.from(record.addedNodes).some((node) =>
      node.nodeType === 1 && (node.id === 'widget-chat-container' || node.id === 'chat-preview-message' || node.querySelector('#widget-chat-container, #chat-preview-message'))
    )) || (bubble && !bubble.isConnected)) schedule();
  });

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }
  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }
  function restoreBubble() {
    if (!bubble) return;
    bubble.removeAttribute('data-latrand-native-overlay');
    bubble.removeAttribute('data-latrand-lifted');
    bubble.style.removeProperty('--latrand-zipchat-lift');
    if (suppressed) bubble.inert = originallyInert;
    suppressed = false;
    if (preview) {
      preview.removeAttribute('data-latrand-lifted');
      preview.style.removeProperty('--latrand-zipchat-preview-bottom');
    }
  }
  function restoreScrollButton(button) {
    const saved = scrollOffsets.get(button);
    if (!saved) return;
    if (saved.value) button.style.setProperty('margin-bottom', saved.value, saved.priority);
    else button.style.removeProperty('margin-bottom');
    restoreScrollVisibility(button, saved);
    scrollOffsets.delete(button);
  }
  function restoreScrollVisibility(button, saved) {
    if (!saved.hidden) return;
    ['visibility', 'pointer-events'].forEach((name) => {
      if (saved[name].value) button.style.setProperty(name, saved[name].value, saved[name].priority);
      else button.style.removeProperty(name);
    });
    if (button.inert !== saved.inert) button.inert = saved.inert;
    saved.hidden = false;
  }
  function clearScrollButtons() {
    scrollOffsets.forEach((_saved, button) => restoreScrollButton(button));
  }
  function updateScrollClearance(chatOpen, hide) {
    const buttons = Array.from(document.querySelectorAll('.scroll-to-top__button'));
    scrollOffsets.forEach((_saved, button) => { if (!buttons.includes(button)) restoreScrollButton(button); });
    if (!bubble?.isConnected || chatOpen || hide || !visible(bubble)) { clearScrollButtons(); return; }
    const bubbleRect = bubble.getBoundingClientRect();
    buttons.forEach((button) => {
      const rect = button.getBoundingClientRect();
      const computed = window.getComputedStyle(button);
      const bottom = Number.parseFloat(computed.bottom);
      if (!Number.isFinite(bottom)) { restoreScrollButton(button); return; }
      const saved = scrollOffsets.get(button) || {
        value: button.style.getPropertyValue('margin-bottom'),
        priority: button.style.getPropertyPriority('margin-bottom'),
        margin: Number.parseFloat(computed.marginBottom) || 0,
        visibility: { value: button.style.getPropertyValue('visibility'), priority: button.style.getPropertyPriority('visibility') },
        'pointer-events': { value: button.style.getPropertyValue('pointer-events'), priority: button.style.getPropertyPriority('pointer-events') },
        inert: button.inert,
        hidden: false
      };
      // Native bottom plus the original margin gives a stable baseline during CSS transitions.
      const nativeBottom = window.innerHeight - bottom - saved.margin;
      const nativeVisible = computed.display !== 'none' && (computed.visibility !== 'hidden' || saved.hidden) &&
        rect.width > 0 && rect.height > 0 && nativeBottom > 0 && nativeBottom - rect.height < window.innerHeight;
      if (!nativeVisible || rect.left >= bubbleRect.right || rect.right <= bubbleRect.left) { restoreScrollButton(button); return; }
      if (bubbleRect.top - 12 - rect.height < 12) {
        scrollOffsets.set(button, saved);
        if (saved.value) {
          if (button.style.getPropertyValue('margin-bottom') !== saved.value || button.style.getPropertyPriority('margin-bottom') !== saved.priority) button.style.setProperty('margin-bottom', saved.value, saved.priority);
        } else if (button.style.getPropertyValue('margin-bottom')) button.style.removeProperty('margin-bottom');
        ['visibility', 'pointer-events'].forEach((name) => {
          const value = name === 'visibility' ? 'hidden' : 'none';
          if (button.style.getPropertyValue(name) !== value || button.style.getPropertyPriority(name) !== 'important') button.style.setProperty(name, value, 'important');
        });
        if (!button.inert) button.inert = true;
        saved.hidden = true;
        return;
      }
      restoreScrollVisibility(button, saved);
      const shift = Math.max(0, Math.ceil(nativeBottom - bubbleRect.top + 12));
      if (!shift) { restoreScrollButton(button); return; }
      scrollOffsets.set(button, saved);
      const value = `${saved.margin + shift}px`;
      if (button.style.getPropertyValue('margin-bottom') !== value || button.style.getPropertyPriority('margin-bottom') !== 'important') {
        button.style.setProperty('margin-bottom', value, 'important');
      }
    });
  }
  function onWidgetTransition(event) {
    if (event.target === bubble) schedule();
  }
  function watchRoots() {
    const nextHost = document.getElementById('zipchat-shadow-host');
    const nextRoot = nextHost?.isConnected && nextHost.shadowRoot?.mode === 'open' ? nextHost.shadowRoot : null;
    const nextBubble = nextRoot?.getElementById('widget-chat-container') || null;
    if (nextHost !== host || nextRoot !== root || nextBubble !== bubble) {
      restoreBubble();
      clearScrollButtons();
      widgetObserver.disconnect();
      root?.removeEventListener('transitionend', onWidgetTransition);
      style?.remove();
      host = nextHost;
      root = nextRoot;
      bubble = nextBubble;
      preview = null;
      if (root) {
        style = document.createElement('style');
        style.id = 'latrand-zipchat-layering-style';
        style.textContent = styles;
        root.appendChild(style);
        widgetObserver.observe(root, { childList: true, subtree: true });
        root.addEventListener('transitionend', onWidgetTransition);
      }
    }
    if (root) preview = root.getElementById('chat-preview-message');
    const nextWatched = Array.from(document.querySelectorAll(nativeRoots));
    const iframe = document.getElementById('zipchat-iframe');
    if (iframe) nextWatched.push(iframe);
    if (bubble) nextWatched.push(bubble);
    if (nextWatched.length !== watched.length || nextWatched.some((node, index) => node !== watched[index])) {
      nativeObserver.disconnect();
      resizeObserver?.disconnect();
      watched = nextWatched;
      watched.forEach((node) => {
        nativeObserver.observe(node, { attributes: true, subtree: node.matches('.section-header, latrand-navigation'), attributeFilter: node === bubble ? ['class', 'hidden', 'style'] : ['class', 'open', 'hidden', 'inert', 'aria-expanded', 'style', 'data-zipchat-visible'] });
        if (node === bubble || node.matches('.sticky-add-to-cart__wrapper, .scroll-to-top__button')) resizeObserver?.observe(node);
      });
    }
  }
  function visible(element) {
    const computed = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return computed.display !== 'none' && computed.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  }
  function update() {
    frame = 0;
    watchRoots();
    if (!bubble?.isConnected) { clearScrollButtons(); return; }
    const chatOpen = document.getElementById('zipchat-iframe')?.getAttribute('data-zipchat-visible') === 'true';
    let hide = Array.from(document.querySelectorAll(nativeOpen)).some((element) => visible(element) ||
      Array.from(element.querySelectorAll('#CartDrawer__Wrapper, #menu-navigation, .lm-panel')).some(visible));
    let lift = 0;
    let previewBottom = null;
    if (mobile.matches && !chatOpen && bubble.style.bottom) {
      const rect = bubble.getBoundingClientRect();
      const baseBottom = Number.parseFloat(window.getComputedStyle(bubble).bottom);
      if (Number.isFinite(baseBottom)) {
        document.querySelectorAll('.sticky-add-to-cart__wrapper').forEach((sticky) => {
          if (!visible(sticky)) return;
          const stickyRect = sticky.getBoundingClientRect();
          if (rect.left < stickyRect.right && rect.right > stickyRect.left) {
            lift = Math.max(lift, window.innerHeight - baseBottom - stickyRect.top + 12);
          }
        });
        lift = Math.max(0, Math.ceil(lift));
        // An expanded native panel with no clear space keeps the launcher hidden.
        if (lift > window.innerHeight - baseBottom - rect.height - 12) { hide = true; lift = 0; }
        if (lift && !bubble.style.transform.includes('translateX')) previewBottom = `${baseBottom + lift + rect.height + 20}px`;
      }
    }
    if (hide) {
      if (!suppressed) { originallyInert = bubble.inert; suppressed = true; }
      setAttribute(bubble, 'data-latrand-native-overlay', '');
      bubble.inert = true;
    } else {
      bubble.removeAttribute('data-latrand-native-overlay');
      if (suppressed) bubble.inert = originallyInert;
      suppressed = false;
    }
    if (lift) {
      setProperty(bubble, '--latrand-zipchat-lift', `${lift}px`);
      setAttribute(bubble, 'data-latrand-lifted', '');
    } else {
      bubble.removeAttribute('data-latrand-lifted');
      bubble.style.removeProperty('--latrand-zipchat-lift');
    }
    if (preview) {
      if (previewBottom) {
        setProperty(preview, '--latrand-zipchat-preview-bottom', previewBottom);
        setAttribute(preview, 'data-latrand-lifted', '');
      } else {
        preview.removeAttribute('data-latrand-lifted');
        preview.style.removeProperty('--latrand-zipchat-preview-bottom');
      }
    }
    updateScrollClearance(chatOpen, hide);
  }
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }
  const lifecycleObserver = new MutationObserver((records) => {
    if ((host && !host.isConnected) || watched.some((node) => !node.isConnected) || records.some((record) => Array.from(record.addedNodes).some((node) =>
      node.nodeType === 1 && (node.matches(discovered) || node.querySelector(discovered))
    ))) schedule();
  });
  function start() {
    schedule();
    if (document.body) lifecycleObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    ['pointerdown', 'focusin'].forEach((name) => document.addEventListener(name, (event) => {
      if (event.target?.nodeType === 1 && (event.target.id === 'zipchat-shadow-host' || event.target.closest(nativeRoots))) schedule();
    }, true));
    document.addEventListener('transitionend', (event) => {
      if (event.target?.nodeType === 1 && event.target.closest('.sticky-add-to-cart__wrapper')) schedule();
    }, true);
    if (document.readyState !== 'complete') window.addEventListener('load', schedule, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
